<template lang="pug">
  div
    // Navbar
    navbar(
      :float="false",
      )
    .container
      .category-panel
        // 選單欄顯示區
        .category-panel-menu
          .tab(
            v-for="(tab,tid) in categoryTabs",
            :class="{'tab-active': tid === activeTab}",
            @click="tabClick(tid,tab.channelId)",
            :key="'tab-'+tid",
            ref="tab"
            ) 
            p {{tab.channelName}}
          a.tab.tab-link(
            v-for="(tabL,lid) in categoryTabsLinks",
            :key="'tabL-'+lid",
            @click="tabClick(lid,tabL.channelId)"
          )
            img(src="@/assets/icons/ic_link_chain_sm.png")
            p {{tabL.channelName}}
        // 內容顯示區
        category-panel-content(
          :categoryContent="categoryContent"
        )
</template>

<script>
import Navbar from '../../components/Navbar.vue';
import CategoryPanelContent from '../../components/CategoryPanelContent.vue';
import {TweenLite,Power4} from 'gsap/TweenMax';
import {mapState,mapActions} from 'vuex';
export default {
  name: 'category-panel',
  components:{
    navbar: Navbar,
    categoryPanelContent: CategoryPanelContent
  },
  data(){
    return{
      baseURL: process.env.VUE_APP_API_BASE_URL,
      activeTab: 0,
      activeTabNumber: null,
    }
  },
  methods:{
    ...mapActions({
      categoryContentRequest: 'categoryContentRequest',
      categoryTabsRequest: 'categoryTabsRequest',
      categoryFirstRequest: 'categoryFirstRequest'
    }),
    tabClick(tid,channelId){
      this.activeTab = tid
      this.activeTabNumber = channelId
      let config = {
        channelId: this.activeTabNumber
      }
      this.categoryContentRequest(config);
    },
    movePanel(){
      if(this.active){
        TweenLite.to(this.$data,0.8,{panelTranslate:0,ease:Power4.easeInOut})
      }else{
        TweenLite.to(this.$data,0.6,{panelTranslate:-this.windowWidth,ease:Power4.easeInOut})
      }
    },
  },
  watch:{
    categoryContent: function(){
      if(this.categoryContent.link==null){
        console.log('no link');
      }else{
        location.href= this.categoryContent.link;
        this.activeTab = 0;
        this.tabClick(this.activeTab,this.tabs[0].channelId);
      }
    },
    active: function(){
      this.movePanel()
    }
  },
  computed:{
    ...mapState({
      categoryInitialNumber: 'categoryInitialNumber',
      categoryTabs: 'categoryTabs',
      categoryTabsLinks: 'categoryTabsLinks',
      categoryContent: 'categoryContent',
    }),
    
  },
  created(){
    this.categoryFirstRequest();
  },
  mounted(){
  },
  destroy(){

  }
}
</script>

<style lang="scss">
  @import '@/assets/style/layout.scss';
  @import '@/assets/style/category.scss';
</style>
